import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { css } from 'styled-components';
export var noTextInteraction = function noTextInteraction() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    text-decoration: none;\n    &:hover,\n    &:focus,\n    &:active,\n    &:visited {\n        text-decoration: none;\n    }\n    outline: none;\n    user-select: none;\n"])));
};
export var reset = function reset() {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    text-align: left;\n    margin: 0;\n    padding: 0;\n\n    word-break: normal;\n    overflow-wrap: normal;\n    white-space: normal;\n"])));
};
export var buttonReset = function buttonReset() {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    appearance: none;\n    border: 0 none;\n    background-color: transparent;\n    border-radius: 0;\n    display: block;\n    padding: 0;\n"])));
};
export var zIndex = function zIndex(_ref) {
  var zIndexValue = _ref.zIndex;
  return zIndex !== undefined ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n              z-index: ", ";\n          "])), zIndexValue) : 0;
};